import { render } from "./BarChartSimple.vue?vue&type=template&id=1a49abc2"
import script from "./BarChartSimple.vue?vue&type=script&lang=js"
export * from "./BarChartSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__